export const RACE_CARD_IDENTITY_TEST_IDS = {
  root: 'race-card-identity',
  eventName: 'race-card-event-name',
  circuit: 'race-card-circuit',
} as const;
